import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { delay, map, type Observable, of } from 'rxjs';

import { environment } from '@env';

import { API_PATHS } from '@kernel';

import { HTTP_CONTEXT_SKIP_ERROR_TOAST } from '@core/http';

import { SKELETON_DELAY_MS } from '@shared/skeleton';

import { filterSearchHits } from './header/search/search.mock';
import { type SearchHit } from './header/search/search.types';

@Injectable({ providedIn: 'root' })
export class ShellService {
  private readonly http = inject(HttpClient);

  search(query: string): Observable<readonly SearchHit[]> {
    if (environment.useMocks) {
      return of(filterSearchHits(query)).pipe(delay(SKELETON_DELAY_MS));
    }

    const params = new HttpParams().set('q', query);

    return this.http
      .get<readonly SearchHit[]>(`${environment.apiUrl}${API_PATHS.search}`, {
        params,
        context: HTTP_CONTEXT_SKIP_ERROR_TOAST,
      })
      .pipe(map((hits) => hits ?? []));
  }
}
